import './assets/main.css';

const hostname = window.location.hostname;
if (hostname.includes('vokraf.com')) {
  document.documentElement.classList.add('theme-lpkken');
} else if (hostname.includes('lpkken.com')) {
  document.documentElement.classList.add('theme-lpkken');
}

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import * as Sentry from '@sentry/vue';

const app = createApp(App);

Sentry.init({
  app,
  dsn: 'https://12591d59c7e33536795db79034d17127@o4506953831546880.ingest.us.sentry.io/4509608055341056',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

app.use(router);
app.mount('#app');
